/**
 * Типы API. Основа сгенерирована из `openapi.json` бекенда
 * (`generated.ts`, править руками нельзя), здесь — только удобные
 * псевдонимы и то, чего в схеме нет.
 *
 * Почему суммы — строки. Бекенд отдаёт денежные величины строками
 * намеренно, и разбирать их в `number` нельзя нигде: у Monero
 * двенадцать знаков после запятой, и `Number("0.123456789012")` уже
 * теряет разряды. Потерянный разряд — это недоплата, а с нулевым
 * допуском недоплата вешает заявку навсегда.
 *
 * Строка приходит, строка показывается, строка копируется.
 * Арифметика — только в `shared/lib/decimal`.
 */

export type {
  ApiKeyCreate,
  ApiKeyIssuedResponse,
  ApiKeyResponse,
  AdminAccountCreate,
  AdminAccountPageResponse,
  AdminAccountResponse,
  AdminAccountUpdate,
  AdminChartResponse,
  AdminOverviewResponse,
  AuditEntryResponse,
  AuditPageResponse,
  AutoWithdrawalCreate,
  AutoWithdrawalListResponse,
  AutoWithdrawalResponse,
  AutoWithdrawalType,
  AutoWithdrawalUpdate,
  BackupCodesResponse,
  BalanceItem,
  BalancesResponse,
  ChartPoint,
  ChartResponse,
  DepositAddressResponse,
  EmailChangeConfirm,
  EmailChangeRequest,
  Currency,
  FiatCurrency,
  InvoiceCreate,
  InvoicePageResponse,
  InvoiceResponse,
  InvoiceStatus,
  MessageResponse,
  OnchainTxPageResponse,
  OnchainTxResponse,
  OverviewResponse,
  PaymentDetails,
  PaymentPageResponse,
  ResetTokenResponse,
  TokenResponse,
  TransactionDetailResponse,
  TransactionPageResponse,
  TransactionResponse,
  TwoFactorSetupResponse,
  TxStatus,
  TxType,
  UserResponse,
  WalletCreate,
  WalletListResponse,
  WebhookDeliveryPageResponse,
  WebhookDeliveryResponse,
  WebhookEndpointIssuedResponse,
  WebhookEndpointResponse,
  WebhookEndpointSet,
  WalletResponse,
  WalletUpdate,
  WithdrawalAdminPageResponse,
  WithdrawalAdminResponse,
  WithdrawalCreate,
  WithdrawalPageResponse,
  WithdrawalResponse,
  WithdrawalStatus,
} from './generated'

import type { InvoiceStatus, TwoFactorRequiredResponse, TokenResponse } from './generated'

/** Заявка закрыта: статус больше не изменится, опрос можно прекращать. */
export const FINAL_INVOICE_STATUSES: ReadonlySet<InvoiceStatus> = new Set<InvoiceStatus>([
  'paid',
  'overpaid',
  'underpaid',
  'expired',
])

/**
 * Ответ входа: либо токен, либо требование второго фактора.
 *
 * В схеме это `anyOf` без различающего поля, поэтому сужаем сами —
 * по наличию `2fa_token`. Перепутать эти две ветки значит либо пустить
 * без второго фактора, либо не пустить вообще.
 */
export type LoginResult = TokenResponse | TwoFactorRequiredResponse

export function needsTwoFactor(
  result: LoginResult,
): result is TwoFactorRequiredResponse {
  return '2fa_token' in result && typeof result['2fa_token'] === 'string'
}

/** Конверт ошибки бекенда: `{"error": {"code", "message", "details"}}`. */
export interface ApiErrorBody {
  error: {
    code: string
    message: string
    details?: Record<string, unknown>
  }
}

/** Общая форма страничного ответа — у всех списков она одна. */
export interface Page<T> {
  items: T[]
  total: number
  limit: number
  offset: number
}
